export interface GoogleMapsClientConfig {
  apiKey: string;
  mapId?: string;
}

let cachedConfig: GoogleMapsClientConfig | null = null;

const envConfig = (): GoogleMapsClientConfig | null => {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_BROWSER_API_KEY;
  if (!apiKey) return null;

  return {
    apiKey,
    mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || undefined,
  };
};

export const getGoogleMapsClientConfig = async (): Promise<GoogleMapsClientConfig> => {
  if (cachedConfig) return cachedConfig;

  const fromEnv = envConfig();
  if (fromEnv) {
    cachedConfig = fromEnv;
    return fromEnv;
  }

  throw new Error('Google Maps browser API key is not configured');
};
